import { useEffect, useMemo } from "react";

import { ObservabilityPipelineHttpMetricsOverview } from "Api/observability/pipeline/types";
import { timeframeToRange } from "src/organization/pages/project/environment/metrics/components/Chart/settings";
import { Poller } from "src/organization/pages/project/environment/metrics/utils/polling/poller";
import { MetricsPollType } from "src/organization/pages/project/environment/metrics/utils/polling/type";
import useObservabilityPipelineHttpClient from "src/organization/pages/project/environment/observabilitySandbox/hooks/useObservabilityPipelineHttpClient";

const useHttpMetricsPoll = ({
  timeframe,
  onChange,
  onError,
  onLoadingChange,
  interval = 30
}: MetricsPollType<ObservabilityPipelineHttpMetricsOverview>) => {
  const client = useObservabilityPipelineHttpClient();

  const poller = useMemo(
    () => new Poller({ onChange, onError, onLoadingChange }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    async function fetchMetrics() {
      const { start, end } = timeframeToRange(timeframe);

      if (!client) {
        return;
      }

      return await client.getHttpMetricsOverview(
        Math.round(start.getTime() / 1000),
        Math.round(end.getTime() / 1000)
      );
    }
    //time with Id does not have a start which makes It is suitable for continous polling
    timeframe.id
      ? poller.startPolling(fetchMetrics, interval)
      : poller.pollOnce(fetchMetrics);
  }, [client, timeframe, interval, poller]);

  useEffect(() => {
    return () => poller.stopPolling();
  }, [poller]);
  return poller;
};

export default useHttpMetricsPoll;
